import get from "lodash/get";
import isEmpty from "lodash/isEmpty";
import ParameterGroup from "./ParameterGroup";

const EMPTY_KEY = "_";

const Parameters = ({ product }) => {
  const groups = get(product, "detailedParameters", []).reduce(
    (carry, param) => {
      const key = param.group ?? EMPTY_KEY;
      (carry[key] = carry[key] || []).push(param);
      return carry;
    },
    {}
  );

  return (
    <>
      {!isEmpty(groups[EMPTY_KEY]) ? (
        <ParameterGroup parameters={groups[EMPTY_KEY]} />
      ) : (
        ""
      )}
      {Object.keys(groups).map((key, index) => {
        if (key === EMPTY_KEY) {
          return "";
        }

        return (
          <ParameterGroup
            key={`parameter-group-${index}-${key}`}
            title={key}
            parameters={groups[key]}
          />
        );
      })}
    </>
  );
};

export default Parameters;
